export default __webpack_public_path__ + "static/media/text-icon.158eb020.svg";